import React from 'react';
import { Box, Typography } from '@mui/material';
import { keyframes } from '@mui/system';

const scrollAnimation = keyframes`
  0% { transform: translateX(100%); }
  100% { transform: translateX(-100%); }
`;

const Scrollingbar = () => {
  return (
    <Box
    
      sx={{
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        backgroundColor: 'rgb(246,160,53)',
        // animation: `${backgroundAnimation} 5s linear infinite`,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '20px',
      }}
      
    >
      <Typography
        variant="h6"
        component="div"
        sx={{
          display: 'inline-block',
          animation: `${scrollAnimation} 28s linear infinite`,
          fontSize: '24px',
          fontWeight: 'bold',
          color:"rgba(0,31,62,0.9)"
        }}
      >
        ✴ WHERE TO START ✴ EMBARKING THE JOURNEY ✴ TOPIC AND RESEARCH PROPOSAL ✴ PROBLEM STATEMENT ✴ BASE PAPERS ✴
        

      </Typography>
    </Box>
  );
};

export default Scrollingbar ;
